import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import secureLogo from "../../assets/images/security-model.png";
import buyTokenTitleBg from "../../assets/card/send-tokens-title-bg.svg";
import Currency from "../assets/Currency.svg";
import Compose from "../assets/Compose.svg";
import Arrow from "../assets/Arrow.svg";
import axios from "axios";
import { refreshTokenV2 } from "../../services/api";
import { baseURL } from "../services/axiosConfig";
import { initialToken } from "../Pages/RoundToJoin/tocken.slice";
import toast, { Toaster } from "react-hot-toast";
import { use } from "react";
import useToastMessage from "../Utiles/Toaster";
import { transactionGTMDetailUpdate, updateToUserInfo } from "./OtpGTM.slice";

const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
};

const SendTokenPopup = ({ onClose, onSubmit, availableTokens = 0, SendTokenPopup, setAvailableTokens }) => {
  const dispatch = useDispatch();
  const { showToast, showErrorToast } = useToastMessage();
  const [form, setForm] = useState({
    tokens: "",
    displayName: "",
    name: "",
    email: "",
    maskedEmail: ""
  });
  const [TokenTransaction, setTokenTransaction] = useState({
    minToken: 0,
    maxToken: 0,
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({
    tokens: false,
    displayName: false,
    email: false,
  });

  const allFilled =
    form?.tokens &&
    Number(form?.tokens) > 0 &&
    Number(form?.tokens) <= availableTokens &&
    form?.displayName &&
    /\S+@\S+\.\S+/.test(form?.email);

  const handleChange = (e) => {
    if (e.target.name === "displayName" && !e.target.value) {
      setForm((prev) => ({
        ...prev,
        displayName: "",
        name: "",
        maskedEmail: "",
        email: "",
        maskedEmail: ""
      }));
      setError("");
      setFieldErrors({ ...fieldErrors, [e.target.name]: false });
    } else {
      setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
      setError("");
      setFieldErrors({ ...fieldErrors, [e.target.name]: false });
    }
  };

  async function fetchProfile() {
    try {
      const token = localStorage.getItem("access_token");
      const profileRes = await axios.get(
        `${baseURL}/accounts/user/me`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        }
      );
      dispatch(initialToken((profileRes?.data?.available_tokens - form?.tokens) + profileRes?.data?.won_tokens));
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshTokenV2(dispatch);
      }
    }
  }

  const handleSend = async (event) => {
    event.preventDefault();
    let newFieldErrors = { tokens: false, displayName: false, email: false };

    if (!form?.tokens || Number(form?.tokens) <= 0) {
      newFieldErrors.tokens = true;
    }
    if (!form?.displayName) {
      newFieldErrors.displayName = true;
    }
    if (!/\S+@\S+\.\S+/.test(form?.email)) {
      newFieldErrors.email = true;
    }

    if (!allFilled) {
      setFieldErrors(newFieldErrors);
      if (Number(form?.tokens) > availableTokens) {
        setError("You don't have enough tokens available.");
      } else if (!/\S+@\S+\.\S+/.test(form?.email)) {
        setError("Please enter a valid email address.");
      } else {
        setError("Please fill all required fields.");
      }
      return;
    }

    setLoading(true);
    setError("");

    try {
      const payload = {
        token_count: Number(form?.tokens),
        display_name: form?.displayName,
        email: form?.email,
        name: form?.name || "",
      };

      const token = localStorage.getItem("access_token");
      if (!token) {
        setError("No access token found. Please log in again.");
        setLoading(false);
        return;
      }

      let authToken;
      try {
        authToken = JSON.parse(token);
      } catch (parseError) {
        console.error("Error parsing access token:", parseError);
        setError("Invalid access token format. Please log in again.");
        setLoading(false);
        return;
      }
      const response = await axios.post(
        `${baseURL}/accounts/send-token/request/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 201) {
        dispatch(transactionGTMDetailUpdate({
          transferId: response.data.transfer_id,
          tokens: Number(form.tokens),
          email: form.email,
          displayName: form.displayName,
          name: form.name || "",
        }))
        onSubmit({
          ...form,
          transferId: response.data.transfer_id,
          tokens: Number(form.tokens),
          email: form.email,
          displayName: form.displayName,
          name: form.name || "",
        });
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        await refreshTokenV2(dispatch);
      }
      else if (err?.response?.status === 500) {
        setError(
          err.response?.data?.error ||
          "Ensure the display name and email match a registered user."
        );
      } else if (err?.response?.data?.error) {
        setError(err.response.data.error);
      } else {
        setError("Failed to send tokens. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  // Token Min Maxed transfer form

  const fetchTokenInfo = async () => {
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get(`${baseURL}/accounts/token-transactions/limit/`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(token)}`,
        },
      });
      if (response.data) {
        setTokenTransaction({
          minToken: response.data.min_tokens || 0,
          maxToken: response.data.max_tokens || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
      if (error?.response?.status === 401) {
        await refreshTokenV2(dispatch);
        fetchProfile();
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTokenInfo();
  }, []);

  // User masked information

  const debouncedFetchUserInfo = useRef(null);

  const fetchUserInfo = async (displayName) => {
    try {
      const token = localStorage.getItem("access_token");
      console.log("Fetching user info for:", displayName);
      const response = await axios.get(
        `${baseURL}/accounts/user-masked/${displayName}/`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        }
      );

      if (response.status === 200) {
        if (response.data.masked_first_name || response.data.masked_email) {
          dispatch(updateToUserInfo({
            name: response.data.masked_first_name || "",
            email: response.data.email || "",
            maskedEmail: response.data.masked_email || "",
            toUserId: response.data.to_user_id || "",
          }));
          setForm((prev) => ({
            ...prev,
            name: response.data.masked_first_name || "",
            email: response.data.email || "",
            maskedEmail: response.data.masked_email || "",
          }));
        } else {
          setForm((prev) => ({
            ...prev,
            name: "",
            email: "",
          }));
          showErrorToast("User Information not found.");
        }
      } else {
        if (displayName) {
          showErrorToast("User Information not found.");
        } else {
          showErrorToast("Failed to fetch user information.");
        }
      }
    } catch (error) {
      if (error.status === 400) {
        showErrorToast(error.response.data.detail);
      }
      if (error?.response?.status === 401) {
        await refreshTokenV2(dispatch);
        fetchProfile();
      }
    }
  };

  useEffect(() => {
    if (!debouncedFetchUserInfo.current) {
      debouncedFetchUserInfo.current = debounce(fetchUserInfo, 500);
    }

    if (form.displayName) {
      debouncedFetchUserInfo.current(form.displayName);
    }
  }, [form.displayName]);

  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 flex justify-center items-center p-4"
      onClick={onClose}
    >
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      <div className="flex items-center justify-center w-full h-full">
        <div
          className="bg-[#F6FAFF] rounded-lg shadow-lg max-w-md w-full max-h-[80vh] flex flex-col overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="relative flex justify-center items-center">
            <img
              src={buyTokenTitleBg}
              alt="Send Tokens"
              className="w-[220px] sm:w-[220px] h-auto mx-auto"
            />
            <button
              className="absolute top-2 right-2 md:right-6 text-[#787878] text-xl sm:text-2xl w-[20px] h-[20px] opacity-100 border-0 flex items-center justify-center"
              onClick={onClose}
            >
              ×
            </button>
          </div>

          <form
            className="p-6 w-full flex flex-col overflow-y-auto"
            onSubmit={handleSend}
          >
            <div className="bg-[#FFFFFF]">
              <div className="text-center font-inter text-[14px] mb-3 mt-3 text-gray-800 flex items-center justify-center gap-2">
                <img src={Currency} alt="Currency icon" width={20} height={20} />
                Available Purchased Token : {availableTokens}
              </div>

              <div className="mb-6 text-center">
                <input
                  type="number"
                  name="tokens"
                  min={1}
                  value={form?.tokens}
                  onChange={handleChange}
                  placeholder="Enter number of tokens*"
                  className={`w-[80%] md:w-[90%] border-2 rounded-full px-3 sm:px-4 py-1.5 sm:py-2 text-center md:text-left text-[#007FFF] outline-none focus:border-[#007FFF] text-sm sm:text-base
                     bg-[#F6FAFF] placeholder:text-center`}
                  style={{ color: form?.tokens ? "#007FFF" : "inherit" }}
                />
                {!form?.tokens && (
                  <style jsx></style>
                )}
                <div className="flex justify-center gap-2 mr-8">
                  {/* <p><span className="text-[14px] text-[#787878] ">Min Tokens
                  </span><span className="text-[14px] text-[#787878]">:</span> <span className="text-[14px] text-[#787878]">{TokenTransaction.minToken}</span></p> */}
                  <p><span className="text-[14px] text-[#787878] ">Max Tokens</span><span className="text-[14px] text-[#787878]">:</span> <span className="text-[14px] text-[#787878]">{TokenTransaction.maxToken}</span></p>
                </div>
              </div>

            </div>

            <div className="flex justify-center mb-4 mt-2">
              <img src={Arrow} alt="Arrow" className="w-5 h-5" />
            </div>

            <div className="bg-[#FFFFFF]">
              <div className="text-center font-inter text-[14px] mt-2 mb-2 text-gray-800 opacity-50">
                To
              </div>

              <div className="mb-4 text-center">
                <input
                  type="text"
                  name="displayName"
                  value={form.displayName}
                  onChange={handleChange}
                  placeholder="Enter display name*"
                  className={`w-[80%] md:w-[90%] border-2 text-[#787878] rounded-full px-3 sm:px-4 py-1.5 sm:py-2 text-center md:text-left outline-none text-sm sm:text-base bg-[#F6FAFF] placeholder:text-center`}
                  style={{ color: form.displayName ? "inherit" : "inherit" }}
                />
                {!form.displayName && (
                  <style jsx></style>
                )}
              </div>

              <div className="mb-4 text-center">
                <input
                  type="text"
                  name="name"
                  disabled
                  readOnly
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Enter name"
                  className="w-[80%] md:w-[90%] text-[#787878] border-2 rounded-full px-3 sm:px-4 py-1.5 sm:py-2 text-center md:text-left outline-none text-sm sm:text-base bg-[#F6FAFF] placeholder:text-center"
                />
              </div>

              <div className="mb-8 text-center">
                <input
                  type="email"
                  name="email"
                  readOnly
                  disabled
                  value={
                    form.maskedEmail
                  }
                  onChange={handleChange}
                  placeholder="Enter email*"
                  className="w-[80%] md:w-[90%] border-2 rounded-full px-3 sm:px-4 py-1.5 sm:py-2 
           text-left outline-none text-sm sm:text-base bg-[#F6FAFF]
           text-[#787878] disabled:text-[#787878] disabled:opacity-100 tracking-[1px] placeholder:text-center"
                />
              </div>
            </div>

            <div className="flex justify-center mb-4">
              <button
                type="submit"
                disabled={!allFilled || loading}
                className={`w-[25%] px-4 py-2 rounded-lg text-base font-archivo transition-colors duration-200 flex items-center justify-center gap-2 mt-4
                  ${allFilled && !loading
                    ? "bg-[#00C05B] text-white hover:bg-[#00a24b] cursor-pointer"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                  }`}
              >
                <img src={Compose} alt="Compose" className="w-5 h-5" />
                {loading ? "Sending..." : "Send"}
              </button>
            </div>
            <div className="text-center text-xs text-gray-500 pb-4">
              <span className="inline-flex items-center gap-1">
                Your security is more important to us{" "}
                <img
                  src={secureLogo}
                  alt="logo"
                  className="inline w-[62.57px] h-[27.23px]"
                />
              </span>
            </div>

            {error && (
              <div className="text-center text-red-500 text-sm mb-4">
                {error}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default SendTokenPopup;